export type Day = {
  date: string;
  dayNum: string;
  weekdayIdx: number;
  inRange: boolean;
  isToday?: boolean;
  temp?: string;
  feels?: string;
};

type WeatherMap = Record<string, { temp?: string; feels?: string }>;

const MONTH_SHORT = [
  "янв.",
  "февр.",
  "март",
  "апр.",
  "май",
  "июн.",
  "июл.",
  "авг.",
  "сент.",
  "окт.",
  "нояб.",
  "дек.",
];

const weekdayMonFirst = (d: Date) => ((d.getDay() + 6) % 7) + 1;

const toISODateLocal = (d: Date) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

export function makeDays(daysCount = 30, weather?: WeatherMap): Day[] {
  const today = new Date();
  const todayISO = toISODateLocal(today);

  const todayMidnight = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  );

  const startWeekday = weekdayMonFirst(todayMidnight);
  const gridStart = new Date(todayMidnight);
  gridStart.setDate(todayMidnight.getDate() - (startWeekday - 1));

  const totalCells = Math.ceil((daysCount + (startWeekday - 1)) / 7) * 7;

  const endDate = new Date(todayMidnight);
  endDate.setDate(todayMidnight.getDate() + (daysCount - 1));
  const endISO = toISODateLocal(endDate);

  const days: Day[] = [];

  for (let i = 0; i < totalCells; i++) {
    const d = new Date(gridStart);
    d.setDate(gridStart.getDate() + i);

    const iso = toISODateLocal(d);
    const wd = weekdayMonFirst(d);

    const inRange = iso >= todayISO && iso <= endISO;

    const base: Day = {
      date: iso,
      dayNum:
        d.getDate() === 1
          ? `${d.getDate()} ${MONTH_SHORT[d.getMonth()]}`
          : String(d.getDate()),
      inRange,
      weekdayIdx: wd,
      isToday: iso === todayISO,
    };

    if (inRange && weather?.[iso]) {
      base.temp = weather[iso].temp;
      base.feels = weather[iso].feels;
    }

    days.push(base);
  }

  return days;
}
